import axios from 'axios'
import {Message, MessageBox} from "element-ui";

const baseURL = 'http://cc.gamebrain.io/'
// const baseURL = 'http://material.cool/'

const fetchInstance = axios.create({
  baseURL:baseURL
})

// request拦截器
fetchInstance.interceptors.request.use(config => {
  if (localStorage.getItem('token') && localStorage.getItem('user_id')) {
    config.data.token = localStorage.getItem('token')
    config.data.user_id = localStorage.getItem('user_id')
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// response拦截器
fetchInstance.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 5002) {
        localStorage.setItem('user_id', '')
        localStorage.setItem('token', '')
        MessageBox.alert('token失效，请重新登陆', '登陆失效', {
          confirmButtonText: '回到登录页',
          callback: action => {
            window.location.href = '/'
          }
        })
      } else {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return response.data
    } else {
      return response.data
    }
  },
  error => {
    console.log('err:' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    // Raven.captureException(error)
    return Promise.reject(error)
  }
)

export default fetchInstance



// WEBPACK FOOTER //
// ./src/api/fetch.js